import React from "react";
import { oneOf, string } from "prop-types";

import "./widget-placeholder.m.css";

const WidgetPlaceholder = ({ url, height, className = "" }) => {
  if (!url) return null;

  return (
    <div className={className} styleName="base" style={{ height: height + "px" }}>
      <iframe
        styleName="iframe"
        className="row-widget"
        scrolling="no"
        frameBorder="no"
        title="row 1 iframe title"
        height={height}
        src={url}
      />
    </div>
  );
};

WidgetPlaceholder.propTypes = {
  className: string,
  url: string,
  height: oneOf([80, 100, 250]).isRequired,
};

export default WidgetPlaceholder;
